export default "__VITE_ASSET__CvMts44t__"